// @flow

import _ from 'lodash';

const Env = {

  COMMON: {
    VERSION: '1.0.0',

    Logger: {
      SENTRY_URL: 'https://3136bac98ac7460ca8d5576a9f002a0b@app.getsentry.com/83979',

      DISPLAY_REPORT_DIALOG: true
    },

    Google: {
      Map: {
        API_URL: 'https://maps.googleapis.com/maps/api/js',

        API_VERSION: '3.26',

        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },

    IS_DEV: false,
    IS_PREPROD: false,
    IS_PROD: false,
  },

  LOCAL: {
    HOSTNAME: 'localhost',
    API_URL: 'http://localhost:8080/rest',

    apikey: 'NTA5MzgyNDc3MDYwNTA1NjpBTzByMWh1X2Z5YjRuOXp4SUlTTFM4Rm9tQQ==',

    IS_DEV: true,

    Google: {
      Map: {
        // TODO
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.preprod.paymytable.com',
  },

  DEV: {
    HOSTNAME: 'restaurant.dev.paymytable.com',
    API_URL: 'https://bo-dot-paymytabledev.appspot.com/rest',

    apikey: 'NTA5MzgyNDc3MDYwNTA1NjpBTzByMWh1X2Z5YjRuOXp4SUlTTFM4Rm9tQQ==',

    IS_DEV: true,

    Google: {
      Map: {
        // TODO
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.preprod.paymytable.com',
  },

  PREPROD: {
    HOSTNAME: 'restaurant.preprod.paymytable.com',
    API_URL: 'https://1-dot-paymytable-eu-preprod.ew.r.appspot.com/rest',

    apikey: 'NTA5MzgyNDc3MDYwNTA1NjpBTzByMWh1X2Z5YjRuOXp4SUlTTFM4Rm9tQQ==',

    IS_PREPROD: true,

    Google: {
      Map: {
        // TODO for now we use the dev one
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.preprod.paymytable.com',
  },

  PRODUCTION: {
    HOSTNAME: 'restaurant.paymytable.com',
    API_URL: 'https://paymytable-eu.ew.r.appspot.com/rest',

    apikey: 'NTc0NzUwNDE0MDI1NTIzMjpJS3dGSUFQYVhoekI=',

    IS_PROD: true,

    Google: {
      Map: {
        // TODO for now we use the dev one
        API_KEY: 'AIzaSyCatd-vZ7uBOKTkfyLJKQ28uszfsmhdTwA'
      }
    },
    BOV2_URL: 'https://bo.paymytable.com',
  }

};


let currentEnv = Env.DEV
const hostname = window.location.hostname

if (hostname === Env.DEV.HOSTNAME || hostname === 'localhost') {
  currentEnv = Env.DEV
} else if (hostname === Env.PREPROD.HOSTNAME) {
  currentEnv = Env.PREPROD
} else if (hostname === Env.PRODUCTION.HOSTNAME) {
  currentEnv = Env.PRODUCTION
}

// if (process.env.__DEV__) {
  // currentEnv = Env.PREPROD
// }

export default _.merge({}, Env.COMMON, currentEnv);



// WEBPACK FOOTER //
// ./scripts/constants/Config.js